import React, { PureComponent } from 'react';

import {
  CustomizedXAxisTick,
  selectFormat,
  StandardTooltip,
  Error
} from './../../../Utils/Utils.js';

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis
} from 'recharts';


class ConversionFunnel extends PureComponent {

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    return (
      <div className="widget--show-first-tick">
        <ResponsiveContainer height={270}>
          <BarChart data={data.data} layout="vertical" margin={{ top: 0, right: 0, left: 15, bottom: 0 }} >

          <Tooltip cursor={{ fill: "#eee", opacity:.5 }} content={
            <StandardTooltip
              render={({ data }) => {

                const payload = data(this.props)

                if (payload !== null) {
                  const tooltip_data = payload[0].payload

                  return (
                    <div className="standard-tooltip">
                      {tooltip_data && tooltip_data.name &&
                        <header className="standard-tooltip__header">
                            <span className="standard-tooltip__value-header">
                              {tooltip_data.name}
                            </span>
                        </header>
                      }
                      <main className="standard-tooltip__main">
                          <div className="standard-tooltip__item">
                            <span className="standard-tooltip__key">
                              <span className="standard-tooltip__icon" style={{ "background": payload[0].color }}></span> 
                              Value
                            </span>
                            <span className="standard-tooltip__value">
                            {selectFormat("number", payload[0].value)}
                            </span>
                          </div>
                      </main>
                    </div>
                  )
                }
              }} />
          } />

            <XAxis type="number" axisLine={false} tickLine={false} mirror={false} dataKey="value" tick={<CustomizedXAxisTick />} />
            <YAxis type="category" axisLine={false} tickLine={false} mirror={false} dataKey="name" />

            <Bar dataKey="value" fill="#eb5b57" barSize={30} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default ConversionFunnel
